var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlbania(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 8.90668H14.4361C14.7044 8.62571 14.8695 8.24532 14.8695 7.82611C14.8695 6.96169 14.1688 6.26091 13.3043 6.26091C12.7597 6.26091 12.2803 6.53916 12 6.96108C11.7196 6.53916 11.2402 6.26091 10.6956 6.26091C9.83122 6.26091 9.13044 6.96169 9.13044 7.82611C9.13044 8.24532 9.29558 8.62575 9.56389 8.90668H5.21741C5.21741 10.0593 6.22133 10.9936 7.37385 10.9936H7.30428C7.30428 12.1463 8.23864 13.0806 9.3913 13.0806C9.3913 13.4539 9.48969 13.8039 9.66144 14.1069L7.93034 15.838L9.2585 17.1661L11.1425 15.2821C11.2163 15.3092 11.2926 15.3309 11.3715 15.3457L10.233 17.9161L12 19.8261L13.7669 17.916L12.6285 15.3456C12.7074 15.3308 12.7837 15.3091 12.8575 15.2821L14.7415 17.166L16.0696 15.8379L14.3385 14.1068C14.5103 13.8038 14.6087 13.4538 14.6087 13.0805C15.7613 13.0805 16.6956 12.1462 16.6956 10.9935H16.6261C17.7786 10.9936 18.7826 10.0593 18.7826 8.90668Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbania);
export default __webpack_public_path__ + "static/media/albania.88f68ee11c6f20b3e44c282ce49eb860.svg";
export { ForwardRef as ReactComponent };